export default {
      id: "btn-add-usage",
      viewBox: "0 0 80 88",
      url: __webpack_public_path__ + "img/icons.50d286a4.svg#btn-add",
      toString: function () {
        return this.url;
      }
    }